import { useEnvironment } from '#cutils/context/EnvironmentContext';

import type { ExternalWeatherReport } from './external-api-types';
import { normalizeWeatherReport } from './mapping';
import { useFetch } from './useFetchState';
import type { WeatherLocation } from './useLocationAPI';

export function useWeatherAPI(location: WeatherLocation | null) {
	const { endpoints } = useEnvironment();

	const { isLoading, hasError, data } = useFetch<ExternalWeatherReport>(
		location?.plz ? `${endpoints.ENDPOINT_REST_API}/weather/${parseInt(location.plz, 10)}` : null
	);

	return { hasError, isLoading, weatherData: data ? normalizeWeatherReport(data) : null };
}
